import { cloneDeep } from '_utils';
import MagazineService from '_services/rest/modules/magazine';
import { MODEL } from './components/MagazineModel';

export default {
  state: {
    magazineList: null,
    magazineEdit: null,
    attachedPuzzles: null,
    detachedPuzzles: null,
  },
  mutations: {
    setMagazineList(state, response) {
      state.magazineList = response;
    },
    setMagazine(state, response) {
      state.magazineEdit = Object.assign(cloneDeep(MODEL), response);
    },
    setAttachedPuzzles(state, response) {
      state.attachedPuzzles = response;
    },
    setDetachedPuzzles(state, response) {
      state.detachedPuzzles = response;
    },
  },
  actions: {
    getMagazineList({ commit }, params) {
      return MagazineService.getList(params)
        .then(response => {
          commit('setMagazineList', response);
        });
    },
    getMagazine({ commit }, params) {
      return MagazineService.getMagazineById(params)
        .then(response => {
          commit('setMagazine', response);
          return response;
        });
    },
    getAttachedMagazinePuzzles({ commit }, params) {
      return MagazineService.getAttachedMagazinePuzzles(params)
        .then(response => {
          commit('setAttachedPuzzles', response.attaches);
          commit('setDetachedPuzzles', response.detaches);
          return response;
        });
    },
  },
};
